import React from 'react';
import PropTypes from 'prop-types';
import {Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../../../componentsReusable/Button";
import api from "../../../../api";
import Icon from "../../../../componentsReusable/Icon";
import _ from "lodash";
import {toast} from "react-toastify";
import {FormattedMessage} from "react-intl";

const UserPrizeCompletionModal = props => {
	const {userPrize} = props;
  const [saving, setSaving] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
	const [userCode, setUserCode] = React.useState(null);
	const [error, setError] = React.useState(null);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  const send = () => {
		setError(null);
    setSaving(true)

    api.userPrize.sendCompletionMail(props.userPrize.id, userCode || null)
      .then((data) => {
				if (data.error) {
					setError(data.error);
				} else {
					toast.success('Nagroda została potwierdzona');
					setModalOpen(false)
				}
      })
      .finally(() => setSaving(false))
  }

  return <React.Fragment>
    <Icon tooltip={'Wyślij maila potwierdzającego nagrodę'} className="fas fa-check cursor-pointer mr-1 p-1" onClick={toggleModalOpen} />
    {modalOpen && <Modal isOpen toggle={toggleModalOpen}>
      <ModalHeader toggle={toggleModalOpen}>Wyślij maila potwierdzającego nagrodę</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
				<p className={'mb-3'}>Nagroda zostanie wysłana do użytkownika <b>{userPrize.userEmail}</b> za nagrodę <b>{userPrize.prizeName}</b></p>
				{!userPrize.milesMoreCard && <React.Fragment>
					<Label><b>Kod użytkownika</b></Label>
					<Input onChange={e => setUserCode(e.target.value)} value={userCode} />
				</React.Fragment>}
				{error && <div className="alert alert-danger">{error}</div>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>Anuluj</Button>
        <Button
          color="primary"
          onClick={send}
          loading={saving}
        >Wyślij</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>;
};

UserPrizeCompletionModal.propTypes = {

};

export default UserPrizeCompletionModal;
